import { getJiraStatusesSlice } from './get';
import { postJiraStatusesSlice } from './post';

export const { requestGetJiraStatuses, resetGetJiraStatuses } = getJiraStatusesSlice.asyncActionCreators;
export const { requestPostJiraStatuses, resetPostJiraStatuses } = postJiraStatusesSlice.asyncActionCreators;
